import React from 'react';

import { useTranslation } from "react-i18next";

const VerificationBanner = ({ userStatus, onVerifyClick }) => {
  const { t } = useTranslation("exchange");
  // Если пользователь уже активен, не показываем баннер
  if (userStatus === 'ACTIVE') {
    return null;
  }

  // Если пользователь не зарегистрирован или имеет статус REGISTERED
  if (userStatus === 'REGISTERED') {
    return (
      <div 
        className="bg-white border-2 border-red-500 rounded-lg p-4 mb-6 cursor-pointer hover:bg-red-50 transition-colors duration-200"
        onClick={onVerifyClick}
      >
        <div className="flex items-center">
          {/* Иконка треугольника с восклицательным знаком */}
          <div className="flex-shrink-0">
            <div className="w-10 h-10 bg-red-500 rounded-full flex items-center justify-center">
              <svg 
                className="w-6 h-6 text-white" 
                fill="currentColor" 
                viewBox="0 0 20 20"
              >
                <path 
                  fillRule="evenodd" 
                  d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" 
                  clipRule="evenodd" 
                />
              </svg>
            </div>
          </div>
          
          {/* Текст */}
          <div className="ml-4 flex-1">
            <h3 className="text-red-600 font-semibold text-base mb-1">
              {t("EXCHANGE_RESTRICT")}
            </h3>
            <p className="text-gray-600 text-sm">
              {t("COMPLETE_IDENTIFY")}
            </p>
          </div>
          
          {/* Стрелочка */}
          <div className="flex-shrink-0 ml-2">
            <svg 
              className="w-5 h-5 text-gray-400" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M9 5l7 7-7 7" 
              />
            </svg>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default VerificationBanner;